export const listKeys = {
  all: () => ['lists'] as const,
  lists: () => [...listKeys.all(), 'list'] as const,
  detail: (id: string) => [...listKeys.all(), 'detail', id] as const,
  members: (id: string) => [...listKeys.all(), 'members', id] as const,
  /** Preview is keyed by the rule tree itself — identical rules, one fetch. */
  preview: (rules: unknown) => [...listKeys.all(), 'preview', rules] as const,
}
